import { mapGetters } from "vuex";
export default {
  name: "Snackbar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getSnackbarAlert"])
  },
  mounted() {},
  methods: {
    hideSnackBar() {
      this.$store.commit("hideToaster");
    }
  }
};
